export default __webpack_public_path__ + "static/media/sello62x62.83e5c0fd.WebP";